import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface ExpertAddedProductToCartEventProperties {
  item_id: string
  user_id: string
  expert_id: string
}

export class ExpertAddedProductToCartEvent extends Event<ExpertAddedProductToCartEventProperties> {
  static displayName = 'Expert Added Product To Cart'

  static allowedViewerContexts = [ViewerContext.BusinessUser]
}
